






















import { Vue, Component, Prop } from 'vue-property-decorator';
import WhiteBlackButton from './WhiteBlackButton.vue';
@Component({ components: { WhiteBlackButton } })
export default class CancelButton extends Vue {
  private css_class = {
    'd-block': true,
    'py-0': true,
    'px-205': true,
    'w-8rem': true,
    'ls-0': true,
  };
  @Prop({ default: 'キャンセル' })
  title!: string;
}
